// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2K5xB","changeGameButton":"App_changeGameButton__1QF-2"};